// src/pages/NotFoundPage.tsx
import * as React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
    return (
        <Box textAlign="center" py={10} px={6}>
            <Text fontSize="4xl" mb={4}>404 - Page non trouvée</Text>
            <Text fontSize="lg" color="gray.500" mb={4}>
                La page que vous recherchez n'existe pas ou a été déplacée.
            </Text>
            <Button as={RouterLink} to="/" colorScheme="teal" variant="solid">
                Retour à l'accueil
            </Button>
        </Box>
    );
};

export default NotFoundPage;
